<template>
  <v-card width="450"
    :loading="isLoading"
  >
    <v-toolbar color="green darken-1" dark flat>
      <v-toolbar-title> Авторизация </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <TextField v-model="credentials.login" label="Email" :rules="[rules.emailRule]"/>
        <TextField v-model="credentials.password" password label="Пароль"/>
      </v-form>    
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="login_user"
        text type="submit" color="primary"
      >
        Войти
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import TextField from '../ui/TextField.vue';
import rules_mixin from '@/mixins/rules_mixin';

export default{

  mixins: [rules_mixin],

  data: () => ({
    isLoading: false,
    credentials:{
      login: null,
      password: null
    }
  }),

  methods: {
    ...mapActions(['login']),

    async login_user(){
      this.isLoading = true;
      await this.login({...this.credentials});
      this.isLoading = false;
    }
  },

  components:{
    TextField
  }
}
</script>